import { api } from './client';
import type { Project } from '@/types/project';
import type { SceneJson, HookConfig } from '@/types/scene';

export const projectsApi = {
  list: async (): Promise<Project[]> => {
    const r = await api.get('api/projects').json<{ projects: Project[] }>();
    return r.projects;
  },

  get: async (id: string): Promise<Project> => {
    const r = await api.get(`api/projects/${id}`).json<{ project: Project }>();
    return r.project;
  },

  create: async (data: {
    title: string;
    sceneJson: SceneJson;
    hookConfig?: HookConfig | null;
    characterId?: string;
  }): Promise<Project> => {
    const r = await api
      .post('api/projects', { json: data })
      .json<{ project: Project }>();
    return r.project;
  },

  update: async (
    id: string,
    patch: Partial<
      Pick<Project, 'title' | 'sceneJson' | 'hookConfig' | 'status' | 'characterId'>
    >,
  ): Promise<Project> => {
    const r = await api
      .put(`api/projects/${id}`, { json: patch })
      .json<{ project: Project }>();
    return r.project;
  },

  delete: (id: string) => api.delete(`api/projects/${id}`).json(),

  duplicate: async (id: string): Promise<Project> => {
    const r = await api
      .post(`api/projects/${id}/duplicate`)
      .json<{ project: Project }>();
    return r.project;
  },
};
